module.exports = __webpack_public_path__ + "d400b7fa1894764a10c62b934974e959.svg";